import type { ListLevel } from '../internal';

export const minHeaderFooterContentHeightIn = 0.1;
export const pageSeparationPx = 16;
export const maxListLevel: ListLevel = 8;
export const superscriptSubscriptFontSizeCoefficient = 0.6;
export const superscriptOffsetCoefficient = 0.4;
export const subscriptOffsetCoefficient = 0.15;
